import React, { useEffect } from "react";
import { useState } from "react";
import { isMobile } from "react-device-detect";
import icon_edit from '../../../components/icons/edit.webp'
import icon_share from '../../../components/icons/share.webp';
import Popup from "reactjs-popup";
import { IconShare2 } from '@tabler/icons-react';
import { useFetch } from "../../../components/api/FetchApiData";
import { GreetingCard,CardEditor, themes } from '../';
if (isMobile)
    import('../components/share_mob.css').then(() => {});
else
    import('../components/share.css').then(() => {});

export default function Share({theme,content,style={fontSize:'xx-small'}})
{
    const fetchData = useFetch();
    const [_content,setContent] = useState(content);
    const [_theme, setTheme] = useState(theme);
    const [notification,setNotification] = useState({text:'',color:'black'});

    const SaveContent = ()=>{
        const  _data = {..._content,is_anonymous:!!_content.is_anonymous?_content.is_anonymous:false};
        fetchData.PutData({'content':_data,'theme':JSON.stringify(_theme)},'user/gifts/').then((result)=>{
            if(result.result)
            {                
                setNotification({text:result.error,color:'green'});
            }
            else {
                setNotification({text:result.error,color:'orangered'});
            }
        })
    };

    return(
    <Popup trigger={
        <input type="button" value={'Partager'} style={{width:'fit-content',fontSize:style.fontSize,color:theme.color,textAlign:'center',backgroundColor:theme.background,borderStyle:'none',border:`1px solid ${theme.color}80`,marginRight:'5px',borderRadius:'10px',padding:'3px 10px'}} />
    }>
        {close=>(
            <div className="dark-screen" style={{backgroundColor:'rgba(0,0,0,0.8)',position:'fixed',top:'0px',left:'0px',width:'100%',height:'100vh'}}>
                <div className="div-card-editor" style={{margin:'auto',width:isMobile?'93%':'70%',maxHeight:'80vh',paddingTop:'30px',paddingBottom:'30px',overflowY:'scroll',backgroundColor:'white',position:'relative',top:'90px',borderRadius:'10px',padding:'10px'}}>
                    <div style={{marginBottom:'10px',marginTop:'10px'}}>
                        <label onClick={()=>{close()}} style={{color:notification.color,padding:'3px 10px',borderRadius:'3px'}}>{notification.text}</label>
                    </div>
                    <CardEditor
                        close={close}
                        initialTheme = {_theme}
                        initialContent = {_content}
                        showOccasionPicker={true}
                        showThemePicker={true}
                        showExportButton={false}
                        onChange={(content, theme) => {
                            setContent(content);
                            setTheme(theme);
                            console.log(content);
                        }}
                    />
                    <button onClick={e=>{SaveContent()}} style={{backgroundColor:'lightgreen',border:'none',padding:'5px 20px 5px 20px',borderRadius:'10px',display:'flex',flexDirection:'row',alignItems:'center',justifyItems:'center', margin:'auto'}}>
                        <img src={icon_share} style={{width:'40px',border:'none',marginRight:'20px'}} />
                        <label style={{marginRight:'20px'}}>Partager</label>
                    </button>
                </div>
            </div>
        )}
    </Popup>);
}